<ng-template [ngIf]="isContratadoAdm" [ngIfElse]="tableCondutores">
    <div class="p-4">
        <breadcrumb [items]="breadcrumb"></breadcrumb>
        <mat-card>
            <mat-card-content>
                <ng-template [ngTemplateOutlet]="tableCondutores"></ng-template>
            </mat-card-content>
        </mat-card>
    </div>
</ng-template>

<ng-template #tableCondutores>
    <div class="d-flex align-items-end mb-3">
        <h1 class="fs-3 fw-light mb-0">Condutores</h1>
        <div class="d-flex align-items-center ms-auto">
            <button mat-icon-button color="primary" class="btn-sm" (click)="toggleFilters = !toggleFilters">
                <mat-icon>tune</mat-icon>
            </button>
            <button mat-flat-button color="primary" class="ms-auto" [routerLink]="['/beneficiaria/', beneficiariaId, 'condutor', 'novo']">
                NOVO CONDUTOR
            </button>
        </div>
    </div>

    <!-- FILTROS -->
    <ng-collapse [toggle]="toggleFilters">
        <div class="border-top pt-3">
            <div class="row">
                <mat-form-field class="col-12 col-md">
                    <mat-label>Nome do condutor</mat-label>
                    <input matInput [(ngModel)]="nomeCondutor"  (keyup.enter)="search()">
                </mat-form-field>               
                <div class="col-12 col-md-auto">
                    <button mat-fab color="accent" type="submit" (click)="search()" [disabled]="loading">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </ng-collapse>

    <generate-table [dataSource]="dataSource" [columns]="columns" [loading]="loading" [total]="pagination.total"
        [pageSize]="pagination.pageSize" (pageEvent)="search($event)"></generate-table>
</ng-template>